import { gql } from '@apollo/client';
import POST_SUMMARY_FIELDS_FRAGMENT from './fragments/PostSummaryFields';

export default gql`
  query favoritePosts {
    currentSession {
      user {
        id
        favoritePosts {
          ...PostSummaryFields
        }
      }
    }
  }
  ${POST_SUMMARY_FIELDS_FRAGMENT}
`;
